import styled from "styled-components";

export const Input = styled.input`
  width: 100%;
  border: 0;
  outline: 0;
  padding: 1rem 2rem;
  margin: 0 0 1rem 0;
  font-family: var(--font);
  font-size: 1rem;
`;
